module.exports = __webpack_public_path__ + "img/poster.64b97003.png";